import { mqMin, space } from '@sunwebgroup/ui-components'
import { Layout } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'
import DestinationMap from '../DestinationSection/DestinationMap'
import Gallery from './Gallery'
import { Header } from './Header'
import Reviews from './Reviews'
import { UrgencyBanner } from './UrgencyBanner'

const Wrapper = styled('div')`
  padding-bottom: ${space('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding-bottom: ${space('primitives_space_24')};
  }
`
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space('primitives_space_16')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    gap: ${space('primitives_space_24')};
  }
`

const UpperContent = styled.div`
  display: flex;
  width: 100%;
  gap: ${space('primitives_space_16')};
  flex-direction: column;

  @media ${mqMin('primitives_breakpoint_l_min')} {
    flex-direction: row;
  }
`

const GalleryWrapper = styled('div')`
  width: 100%;
`

const Sidebar = styled('div')`
  display: flex;
  gap: ${space('primitives_space_16')};
  width: 100%;
  flex-direction: column;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    flex-direction: row;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    width: 350px;
    min-width: 350px;
    flex-direction: column;
  }
`

export function HeroSection() {
  return (
    <Wrapper>
      <Layout>
        <Header />
        <Content>
          <UpperContent>
            <GalleryWrapper>
              <Gallery />
            </GalleryWrapper>
            <Sidebar>
              <Reviews isHeroSection />
              <DestinationMap isHeroSection />
            </Sidebar>
          </UpperContent>
          <UrgencyBanner />
        </Content>
      </Layout>
    </Wrapper>
  )
}
